import { useState, useEffect } from "react";

//** Context */
import usePreQualificationPages from "../hooks/usePreQualificationPages";
import usePreQualification from "../hooks/usePreQualification";
import { Navigate, useLocation } from "react-router-dom";

// const loadFirstPage = async (funcs, funcSet) => {
//   funcSet.resetData(); // Make sure we clear down the data.
//   const responsePage = funcs.getStartPage();
//   return <Navigate replace to={responsePage.responsePage.routePath} />;
// };

export default function PageGuard({ children }) {
	try {
		const { funcs } = usePreQualificationPages();
		const { funcSet } = usePreQualification();

		// !! Check to ensure that we can go to a specific page
		// !! If the page is valid or the  page is next in the page sequence, allow access
		// !! else return to the last valid page.

		// ? Get this from the Pages Context - Pass in the index of the page we are trying to access
		const pageIndex = { ...children }.props.pageIndex;

		// Check if this is a page reload (F5)
		useEffect(() => {
			window.onbeforeunload = (e) => {
				return "";
			};
			/* Commenting the below code, when the page refresh the app loads again and reset everything, similar to how 
         its working in the CC flow, where don't have the code.
         During retrieve it was intermittently causing issue where post OTP verification -->user navigated to --> retrieve-loading page
         then the method was getting called and causing the redirect to the first page. Its very intermittently and tough to reproduce.
         Based on the debug and the only difference between online and CCflow , its suspected to be this code. This behavior is not noticed in CC.
         Tough to reproduce, will test and check if its observed again and working as expected.
      */
			// if (
			//   window.performance.getEntriesByType("navigation")[0].type === "reload"
			// ) {
			//   // If it is, just reload the first page.
			//   loadFirstPage(funcs, funcSet);
			// }
		}, []);

		// Ensure we are allowed to navigate to the requested page
		const responsePage = funcs.getRequestPage({
			requestPageIndex: pageIndex,
		});

		// Check if this is a navigation 'back'
		if (
			responsePage.allowPageRequest === false ||
			responsePage.isBack === true
		) {
			return <Navigate to={responsePage.responsePage.previousRoutePath} />;
		}

		// No issue, load the page.
		return <>{children}</>;
	} catch (ex) {
		console.error(ex);
	}
}
